<!--
 * @Author: ningbo.kang
 * @Date: 2019-12-25 10:41:57
 * @LastEditors: ningbo.kang
 * @LastEditTime: 2020-07-07 15:19:40
 * @Description: 描述
 -->

<template>
  <a-form-item
    v-if="!options.hidden"
    :label="label"
    :class="[{ 'ant-form-item-disabled': disabled }]"
    :required="!disabled && required"
  >
    <widgetItem
      :fieldName="widget.model"
      :widget="widget" :disabled="disabled"
      :isNested="isNested"
      :showLabel="showLabel"
      :rowIndex="rowIndex"
      :parentName="parentName"
      :parentModel="parentModel"
      v-decorator="decorator"
      @noticeParent="handleNoticeParent"
      @change="handleChange"
    >
    </widgetItem>
  </a-form-item>
</template>
<script>
import props from '../../lib/props';
import widgetItem from './slider';

export default {
  name: 'wgSlider',
  mixins: [props],
  components: {
    widgetItem,
  },
  methods: {},
};
</script>
